import React from 'react';
import cx from 'classnames';
import '../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../common/GradientWrapper/index.js';
import { Icon } from '../../common/Icon/index.js';
import '../../common/LazyImage/index.js';
import '../../common/NumberFormat/index.js';
import '../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const AuthPromo = ({
  title,
  list,
  image,
  className,
  style,
  imageCenter,
  imageRight,
  imageLeft
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className, "auth-promo-card"), style }, /* @__PURE__ */ React.createElement("img", { src: image, alt: "" }), /* @__PURE__ */ React.createElement("div", { className: cx(styles["image-center"], "modal-animate-image") }, /* @__PURE__ */ React.createElement("img", { src: imageCenter, alt: "" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles["image-right"], "modal-animate-image") }, /* @__PURE__ */ React.createElement("img", { src: imageRight, alt: "" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles["image-left"], "modal-animate-image") }, /* @__PURE__ */ React.createElement("img", { src: imageLeft, alt: "" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles.content, "auth-promo-card__content") }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title, "auth-promo-card__title") }, title), /* @__PURE__ */ React.createElement("div", { className: cx(styles.list, "auth-promo-card__list") }, list.map((item, i) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.list__item, "auth-promo-card__list-item"),
    key: i
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.bullet }, /* @__PURE__ */ React.createElement(Icon, { iconName: "ListBullet" })),
  item
)))));
AuthPromo.displayName = "AuthPromo";

export { AuthPromo };
//# sourceMappingURL=index.js.map
